<template>
<div>
  <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div class="row" v-if="invoices.length">
      <div class="w-100 mt-3 overflow-hidden rounded">
        <table class="table">
          <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Name</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Number</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Value</th>
            <th class="d-none d-sm-table-cell text-center" scope="col">Pending From</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in invoices" v-bind:key="i" class="pointer">
            <th @click="renderInvoice(row)" scope="row">{{moment(row.createdAt).format('DD.MM.yyyy HH:mm')}}</th>
            <td @click="renderInvoice(row)">{{row.client.name || "No name"}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.number}}</td>
            <td class="d-none d-sm-table-cell text-center">{{row.items.reduce((value, item) => value += item.qtt * item.price, 0).toLocaleString('en')}} kr</td>
            <td v-if="row.canceled" class="d-none d-sm-table-cell text-center text-danger">CANCELED</td>
            <td v-else-if="row.paid" class="d-none d-sm-table-cell text-center text-success"><b-button variant="success" @click="cancelInvoice(row._id)">DONE</b-button></td>
            <td v-else class="d-none d-sm-table-cell text-center"><b-button @click="setAsPaid(row._id)" size="sm">{{moment(row.createdAt).fromNow()}}</b-button></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <div class="w-100 text-center mt-3">
        <h5>No pending invoices</h5>
      </div>
    </div>
</div>

</template>

<script>
import axios from 'axios';
import moment from 'moment';

import fixed from '../../fixed';

const API_URL = `${fixed.API_URL}/admin`;
export default {
  data: () => ({
    loading: false,
    invoices: [],
    moment,
  }),
  mounted() {
    this.getPendingInvoices();
  },
  methods: {
    async getPendingInvoices() {
      this.loading = true;

      try {
        const { data } = await axios.get(`${API_URL}/get-pending-invoices`, { withCredentials: true });
        this.invoices = data || [];
      } catch (error) {
        this.$toast.error('can\'t fetch invoices');
      }
      this.loading = false;
    },
    async setAsPaid(id) {
      const ok = confirm('Are you sure you want to set this invoice as paid?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${API_URL}/invoice-state`, { _id: id, state: true }, { withCredentials: true });
        this.$toast.success('invoice state changed successfully');
        this.getInvoices();
      } catch (err) {
        this.$toast.error('can\'t set invoice state');
      }
      this.loading = false;
    },
    async cancelInvoice(_id) {
      const ok = confirm('Are you sure you want to cancel this invoice?'); // eslint-disable-line
      if (!ok) return;

      this.loading = true;
      try {
        await axios.put(`${API_URL}/cancel-invoice`, { _id }, { withCredentials: true });
        this.getInvoices();
      } catch (err) {
        this.$$toast.error('can\'t cancel the invoice, check stock counts');
      }
    },
    async renderInvoice(invoice) {
      this.loading = true;

      try {
        const { data } = await axios.post(`${API_URL}/otf-invoice`, invoice, { withCredentials: true, responseType: 'arraybuffer' });
        const blob = new Blob([data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      } catch (err) {
        this.$toast.error('can\'t render invoice');
      }
      this.loading = false;
    },
  },
};
</script>

<style>

</style>
